import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import { getSetting, updateSetting } from "../../services/settingServices";
import * as Yup from "yup";
import { toast } from "react-toastify";

export default function GeneralSettings() {
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    rector_email: "",
    proforma_link: "",
  });
  
  const [loading, setLoading] = useState(true);

  const handleCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    getSetting()
      .then((data) => {
        setInitialValues({
          rector_email: data?.rector_email || "",
          proforma_link: data?.proforma_link || "",
        });
      })
      .catch((err) => {
        toast.error("No hay datos de configuración");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);
  

  const validationSchema = Yup.object({
    rector_email: Yup.string()
      .email("Correo inválido")
      .required("Este campo es obligatorio"),
    proforma_link: Yup.string().required("Este campo es obligatorio"),
  });

  const onSubmit = async (values) => {
    try {
      await updateSetting(values);
      toast.success("Configuración guardada correctamente");
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
        console.error(err);
      } else {
        toast.error("Error al guardar configuración");
      }
    }
  };

  if (loading) {
    return (
      <Box sx={{ p: 5, textAlign: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 5 }}>
      <Typography variant="subtitle1" component="span" sx={{ fontWeight: "bold" }}>
        Configuración General
      </Typography>

      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <Grid container direction="row" spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <Field
                  as={TextField}
                  name="rector_email"
                  type="email"
                  size="small"
                  fullWidth
                  label="Correo del rector *"
                  placeholder="Correo del rector *"
                  variant="outlined"
                  value={props.values.rector_email}
                  error={
                    !!props.errors.rector_email && props.touched.rector_email
                  }
                  helperText={<ErrorMessage name="rector_email" />}
                />
              </Grid>

              <Grid item xs={6}>
                <Field
                  as={TextField}
                  name="proforma_link"
                  type="text"
                  size="small"
                  fullWidth
                  label="Enlace de ejemplos de proforma *"
                  placeholder="Enlace de ejemplos de proforma *"
                  variant="outlined"
                  value={props.values.proforma_link}
                  error={
                    !!props.errors.proforma_link && props.touched.proforma_link
                  }
                  helperText={<ErrorMessage name="proforma_link" />}
                />
              </Grid>

              <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 4 }}>
                <Grid item>
                  <Button variant="contained" type="submit" size="large">
                    Guardar
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" onClick={handleCancel} size="large">
                    Cancelar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
